import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CalculatorFilledSvg from "@ant-design/icons-svg/es/asn/CalculatorFilled";
import AntdIcon from "../components/AntdIcon";
var CalculatorFilled = function CalculatorFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalculatorFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CalculatorFilled.displayName = 'CalculatorFilled';
}
export default /*#__PURE__*/React.forwardRef(CalculatorFilled);